const calendarLocalization = {
  prevMonthLabel: 'Previous month',
  nextMonthLabel: 'Next month',
  monthSelectLabel: 'Month',
  yearSelectLabel: 'Year',
  weekLabel: 'Week',
}

export default calendarLocalization
